/* eslint-disable no-nested-ternary */ /* eslint-disable no-invalid-this */ const $0a772f3870b26b4c$var$config = {
    step: 20,
    levels: 10,
    noiseScale: 0.005,
    speed: 0.0005,
    lineWidth: 5,
    thresholds: []
};
const $0a772f3870b26b4c$var$perlin = new function() {
    this.p = new Uint8Array(512);
    const permutation = new Uint8Array([
        151,
        160,
        137,
        91,
        90,
        15,
        131,
        13,
        201,
        95,
        96,
        53,
        194,
        233,
        7,
        225,
        140,
        36,
        103,
        30,
        69,
        142,
        8,
        99,
        37,
        240,
        21,
        10,
        23,
        190,
        6,
        148,
        247,
        120,
        234,
        75,
        0,
        26,
        197,
        62,
        94,
        252,
        219,
        203,
        117,
        35,
        11,
        32,
        57,
        177,
        33,
        88,
        237,
        149,
        56,
        87,
        174,
        20,
        125,
        136,
        171,
        168,
        68,
        175,
        74,
        165,
        71,
        134,
        139,
        48,
        27,
        166,
        77,
        146,
        158,
        231,
        83,
        111,
        229,
        122,
        60,
        211,
        133,
        230,
        220,
        105,
        92,
        41,
        55,
        46,
        245,
        40,
        244,
        102,
        143,
        54,
        65,
        25,
        63,
        161,
        1,
        216,
        80,
        73,
        209,
        76,
        132,
        187,
        208,
        89,
        18,
        169,
        200,
        196,
        135,
        130,
        116,
        188,
        159,
        86,
        164,
        100,
        109,
        198,
        173,
        186,
        3,
        64,
        52,
        217,
        226,
        250,
        124,
        123,
        5,
        202,
        38,
        147,
        118,
        126,
        255,
        82,
        85,
        212,
        207,
        206,
        59,
        227,
        47,
        16,
        58,
        17,
        182,
        189,
        28,
        42,
        223,
        183,
        170,
        213,
        119,
        248,
        152,
        2,
        44,
        154,
        163,
        70,
        221,
        153,
        101,
        155,
        167,
        43,
        172,
        9,
        129,
        22,
        39,
        253,
        19,
        98,
        108,
        110,
        79,
        113,
        224,
        232,
        178,
        185,
        112,
        104,
        218,
        246,
        97,
        228,
        251,
        34,
        242,
        193,
        238,
        210,
        144,
        12,
        191,
        179,
        162,
        241,
        81,
        51,
        145,
        235,
        249,
        14,
        239,
        107,
        49,
        192,
        214,
        31,
        181,
        199,
        106,
        157,
        184,
        84,
        204,
        176,
        115,
        121,
        50,
        45,
        127,
        4,
        150,
        254,
        138,
        236,
        205,
        93,
        222,
        114,
        67,
        29,
        24,
        72,
        243,
        141,
        128,
        195,
        78,
        66,
        215,
        61,
        156,
        180
    ]);
    for(let i = 0; i < 256; i++)this.p[i] = this.p[i + 256] = permutation[i];
    function fade(t) {
        return t * t * t * (t * (t * 6 - 15) + 10);
    }
    function lerp(t, a, b) {
        return a + t * (b - a);
    }
    function grad(hash, x, y, z) {
        const h = hash & 15;
        const u = h < 8 ? x : y;
        const v = h < 4 ? y : h === 12 || h === 14 ? x : z;
        return ((h & 1) === 0 ? u : -u) + ((h & 2) === 0 ? v : -v);
    }
    this.noise = function(x, y, z) {
        const X = Math.floor(x) & 255;
        const Y = Math.floor(y) & 255;
        const Z = Math.floor(z) & 255;
        x -= Math.floor(x);
        y -= Math.floor(y);
        z -= Math.floor(z);
        const u = fade(x), v = fade(y), w = fade(z);
        const A = this.p[X] + Y, AA = this.p[A] + Z, AB = this.p[A + 1] + Z;
        const B = this.p[X + 1] + Y, BA = this.p[B] + Z, BB = this.p[B + 1] + Z;
        return lerp(w, lerp(v, lerp(u, grad(this.p[AA], x, y, z), grad(this.p[BA], x - 1, y, z)), lerp(u, grad(this.p[AB], x, y - 1, z), grad(this.p[BB], x - 1, y - 1, z))), lerp(v, lerp(u, grad(this.p[AA + 1], x, y, z - 1), grad(this.p[BA + 1], x - 1, y, z - 1)), lerp(u, grad(this.p[AB + 1], x, y - 1, z - 1), grad(this.p[BB + 1], x - 1, y - 1, z - 1))));
    };
}();
const $0a772f3870b26b4c$var$canvas = document.getElementById('topo');
const $0a772f3870b26b4c$var$ctx = $0a772f3870b26b4c$var$canvas.getContext('2d');
let $0a772f3870b26b4c$var$width, $0a772f3870b26b4c$var$height;
let $0a772f3870b26b4c$var$time = 0;
for(let i = 0; i < $0a772f3870b26b4c$var$config.levels; i++)$0a772f3870b26b4c$var$config.thresholds.push(-0.6 + i * 1.2 / ($0a772f3870b26b4c$var$config.levels - 1));
function $0a772f3870b26b4c$var$resize() {
    $0a772f3870b26b4c$var$width = $0a772f3870b26b4c$var$canvas.width = window.innerWidth;
    $0a772f3870b26b4c$var$height = $0a772f3870b26b4c$var$canvas.height = window.innerHeight;
}
window.addEventListener('resize', $0a772f3870b26b4c$var$resize);
$0a772f3870b26b4c$var$resize();
function $0a772f3870b26b4c$var$lerpPos(p1, p2, v1, v2, t) {
    return p1 + (p2 - p1) * (t - v1) / (v2 - v1);
}
function $0a772f3870b26b4c$var$getState(v1, v2, v3, v4, t) {
    return (v1 >= t ? 8 : 0) + (v2 >= t ? 4 : 0) + (v3 >= t ? 2 : 0) + (v4 >= t ? 1 : 0);
}
function $0a772f3870b26b4c$var$animate() {
    $0a772f3870b26b4c$var$ctx.fillStyle = '#050505';
    $0a772f3870b26b4c$var$ctx.fillRect(0, 0, $0a772f3870b26b4c$var$width, $0a772f3870b26b4c$var$height);
    $0a772f3870b26b4c$var$time += $0a772f3870b26b4c$var$config.speed;
    $0a772f3870b26b4c$var$ctx.lineWidth = $0a772f3870b26b4c$var$config.lineWidth;
    $0a772f3870b26b4c$var$config.thresholds.forEach((threshold, index)=>{
        const alpha = 0.05 + index / $0a772f3870b26b4c$var$config.levels * 0.8;
        $0a772f3870b26b4c$var$ctx.strokeStyle = `rgba(255, 255, 255, ${alpha})`;
        $0a772f3870b26b4c$var$ctx.beginPath();
        for(let x = 0; x < $0a772f3870b26b4c$var$width; x += $0a772f3870b26b4c$var$config.step)for(let y = 0; y < $0a772f3870b26b4c$var$height; y += $0a772f3870b26b4c$var$config.step){
            const v1 = $0a772f3870b26b4c$var$perlin.noise(x * $0a772f3870b26b4c$var$config.noiseScale, y * $0a772f3870b26b4c$var$config.noiseScale, $0a772f3870b26b4c$var$time);
            const v2 = $0a772f3870b26b4c$var$perlin.noise((x + $0a772f3870b26b4c$var$config.step) * $0a772f3870b26b4c$var$config.noiseScale, y * $0a772f3870b26b4c$var$config.noiseScale, $0a772f3870b26b4c$var$time);
            const v3 = $0a772f3870b26b4c$var$perlin.noise((x + $0a772f3870b26b4c$var$config.step) * $0a772f3870b26b4c$var$config.noiseScale, (y + $0a772f3870b26b4c$var$config.step) * $0a772f3870b26b4c$var$config.noiseScale, $0a772f3870b26b4c$var$time);
            const v4 = $0a772f3870b26b4c$var$perlin.noise(x * $0a772f3870b26b4c$var$config.noiseScale, (y + $0a772f3870b26b4c$var$config.step) * $0a772f3870b26b4c$var$config.noiseScale, $0a772f3870b26b4c$var$time);
            const state = $0a772f3870b26b4c$var$getState(v1, v2, v3, v4, threshold);
            if (state === 0 || state === 15) continue;
            const top = {
                x: $0a772f3870b26b4c$var$lerpPos(x, x + $0a772f3870b26b4c$var$config.step, v1, v2, threshold),
                y: y
            };
            const right = {
                x: x + $0a772f3870b26b4c$var$config.step,
                y: $0a772f3870b26b4c$var$lerpPos(y, y + $0a772f3870b26b4c$var$config.step, v2, v3, threshold)
            };
            const bottom = {
                x: $0a772f3870b26b4c$var$lerpPos(x, x + $0a772f3870b26b4c$var$config.step, v4, v3, threshold),
                y: y + $0a772f3870b26b4c$var$config.step
            };
            const left = {
                x: x,
                y: $0a772f3870b26b4c$var$lerpPos(y, y + $0a772f3870b26b4c$var$config.step, v1, v4, threshold)
            };
            switch(state){
                case 1:
                    $0a772f3870b26b4c$var$ctx.moveTo(bottom.x, bottom.y);
                    $0a772f3870b26b4c$var$ctx.lineTo(left.x, left.y);
                    break;
                case 2:
                    $0a772f3870b26b4c$var$ctx.moveTo(right.x, right.y);
                    $0a772f3870b26b4c$var$ctx.lineTo(bottom.x, bottom.y);
                    break;
                case 3:
                    $0a772f3870b26b4c$var$ctx.moveTo(right.x, right.y);
                    $0a772f3870b26b4c$var$ctx.lineTo(left.x, left.y);
                    break;
                case 4:
                    $0a772f3870b26b4c$var$ctx.moveTo(top.x, top.y);
                    $0a772f3870b26b4c$var$ctx.lineTo(right.x, right.y);
                    break;
                case 5:
                    $0a772f3870b26b4c$var$ctx.moveTo(top.x, top.y);
                    $0a772f3870b26b4c$var$ctx.lineTo(left.x, left.y);
                    $0a772f3870b26b4c$var$ctx.moveTo(right.x, right.y);
                    $0a772f3870b26b4c$var$ctx.lineTo(bottom.x, bottom.y);
                    break;
                case 6:
                    $0a772f3870b26b4c$var$ctx.moveTo(top.x, top.y);
                    $0a772f3870b26b4c$var$ctx.lineTo(bottom.x, bottom.y);
                    break;
                case 7:
                    $0a772f3870b26b4c$var$ctx.moveTo(top.x, top.y);
                    $0a772f3870b26b4c$var$ctx.lineTo(left.x, left.y);
                    break;
                case 8:
                    $0a772f3870b26b4c$var$ctx.moveTo(top.x, top.y);
                    $0a772f3870b26b4c$var$ctx.lineTo(left.x, left.y);
                    break;
                case 9:
                    $0a772f3870b26b4c$var$ctx.moveTo(top.x, top.y);
                    $0a772f3870b26b4c$var$ctx.lineTo(bottom.x, bottom.y);
                    break;
                case 10:
                    $0a772f3870b26b4c$var$ctx.moveTo(top.x, top.y);
                    $0a772f3870b26b4c$var$ctx.lineTo(right.x, right.y);
                    $0a772f3870b26b4c$var$ctx.moveTo(bottom.x, bottom.y);
                    $0a772f3870b26b4c$var$ctx.lineTo(left.x, left.y);
                    break;
                case 11:
                    $0a772f3870b26b4c$var$ctx.moveTo(top.x, top.y);
                    $0a772f3870b26b4c$var$ctx.lineTo(right.x, right.y);
                    break;
                case 12:
                    $0a772f3870b26b4c$var$ctx.moveTo(right.x, right.y);
                    $0a772f3870b26b4c$var$ctx.lineTo(left.x, left.y);
                    break;
                case 13:
                    $0a772f3870b26b4c$var$ctx.moveTo(right.x, right.y);
                    $0a772f3870b26b4c$var$ctx.lineTo(bottom.x, bottom.y);
                    break;
                case 14:
                    $0a772f3870b26b4c$var$ctx.moveTo(bottom.x, bottom.y);
                    $0a772f3870b26b4c$var$ctx.lineTo(left.x, left.y);
                    break;
                default:
                    break;
            }
        }
        $0a772f3870b26b4c$var$ctx.stroke();
    });
    requestAnimationFrame($0a772f3870b26b4c$var$animate);
}
$0a772f3870b26b4c$var$animate();


console.log("%c\uD83D\uDE01 ", 'font-size: 48px;');
console.log('%cCurious? ', 'font-size: 24px; font-weight: bold; color: "purple";');
console.log('%cNeed a frontend developer?', 'font-size: 16px; font-weight: bold;');
console.log("%cYou\u2018re in the right place!", 'font-size: 16px; font-weight: bold;');
// ─── Lang query param ────────────────────────────────────────────────────────
const $388b617130f03bd4$var$params = new URLSearchParams(location.search);
const $388b617130f03bd4$var$lang = $388b617130f03bd4$var$params.get('lang');
if ($388b617130f03bd4$var$lang) {
    localStorage.setItem('lang', $388b617130f03bd4$var$lang);
    document.documentElement.lang = $388b617130f03bd4$var$lang;
    document.documentElement.className = document.documentElement.className.replace(/\blang-\w+/g, '') + ' lang-' + $388b617130f03bd4$var$lang;
}
function $388b617130f03bd4$var$$qa(selector, parent = document) {
    return Array.from(parent.querySelectorAll(selector));
}
function $388b617130f03bd4$var$$q(selector, parent = document) {
    return parent.querySelector(selector);
}
function $388b617130f03bd4$var$addClass(element, className) {
    if (element) element.classList.add(className);
}
function $388b617130f03bd4$var$removeClass(element, className) {
    if (element) element.classList.remove(className);
}
function $388b617130f03bd4$var$containsClass(element, className) {
    if (element) return element.classList.contains(className);
    return false;
}
$388b617130f03bd4$var$$qa('.reference').forEach(($el, i)=>{
    $el.style.transitionDelay = i * 0.1 + 's';
});
$388b617130f03bd4$var$$qa('.awards-container p span').forEach(($el, i)=>{
    $el.style.transitionDelay = i * 0.1 + 's';
});
$388b617130f03bd4$var$$qa('.clients-container img').forEach(($el, i)=>{
    $el.style.transitionDelay = 3.5 + i * 0.1 + 's';
});
// ─────────────────────────────────────────────────────────────────────────────
const $388b617130f03bd4$var$isMobile = ()=>/(Android|webOS|Phone|iPad|iPod|BlackBerry|Windows Phone)/i.test(navigator.userAgent);
const $388b617130f03bd4$var$debounce = (fn, delay)=>{
    let last;
    let timer;
    return function(...args) {
        const now = Date.now();
        if (last && now < last + delay) {
            clearTimeout(timer);
            timer = setTimeout(()=>{
                last = now;
                fn(...args);
            }, delay);
            return timer;
        } else {
            last = now;
            return fn(...args);
        }
    };
};
document.addEventListener('DOMContentLoaded', ()=>{
    const slideContainer = $388b617130f03bd4$var$$q('.slide-container');
    const pageContainer = $388b617130f03bd4$var$$q('.work-container');
    const pageNavigation = $388b617130f03bd4$var$$q('.work-pagination');
    const totalWorks = $388b617130f03bd4$var$$qa('.work').length;
    const references = $388b617130f03bd4$var$$q('.references');
    const referencesWrapper = $388b617130f03bd4$var$$q('.references-wrapper');
    const referenceNavigation = $388b617130f03bd4$var$$q('.reference-pagination');
    const referenceCards = $388b617130f03bd4$var$$qa('.reference', referencesWrapper || document);
    const animationEnd = 'animationend';
    const angle = {
        cube: 0
    };
    const face = {
        cube: 0
    };
    let totalPages = totalWorks;
    let page = 1;
    let totalReferencePages = referenceCards.length;
    let referencePage = 1;
    // ─── Cube 3D ────────────────────────────────────────────────────────────
    const rotateCube = (type)=>{
        angle[type] += 90;
        face[type] += 1;
        if (face[type] >= 4) face[type] = 0;
        const cubeFaces = $388b617130f03bd4$var$$qa('.' + type + ' div');
        cubeFaces.forEach((faceElement)=>{
            $388b617130f03bd4$var$removeClass(faceElement, 'active');
        });
        if (cubeFaces[face[type]]) $388b617130f03bd4$var$addClass(cubeFaces[face[type]], 'active');
        const cube = $388b617130f03bd4$var$$q('.' + type);
        if (cube) cube.style.transform = 'rotateX(' + angle[type] + 'deg)';
        setTimeout(()=>{
            rotateCube(type);
        }, Math.random() * 1000 + 1000);
    };
    rotateCube('cube');
    if (references && referencesWrapper && !$388b617130f03bd4$var$isMobile()) {
        let tiltFrame = null;
        let isOverReferencesLink = false;
        let targetRotateX = 0;
        let targetRotateY = 0;
        let currentRotateX = 0;
        let currentRotateY = 0;
        const renderTilt = ()=>{
            currentRotateX += (targetRotateX - currentRotateX) * 0.12;
            currentRotateY += (targetRotateY - currentRotateY) * 0.12;
            referencesWrapper.style.setProperty('--tilt-x', currentRotateX.toFixed(2) + 'deg');
            referencesWrapper.style.setProperty('--tilt-y', currentRotateY.toFixed(2) + 'deg');
            const stillAnimating = Math.abs(targetRotateX - currentRotateX) > 0.01 || Math.abs(targetRotateY - currentRotateY) > 0.01;
            if (stillAnimating) tiltFrame = requestAnimationFrame(renderTilt);
            else tiltFrame = null;
        };
        const queueTiltRender = ()=>{
            if (!tiltFrame) tiltFrame = requestAnimationFrame(renderTilt);
        };
        const resetTiltImmediately = ()=>{
            targetRotateX = 0;
            targetRotateY = 0;
            currentRotateX = 0;
            currentRotateY = 0;
            if (tiltFrame) {
                cancelAnimationFrame(tiltFrame);
                tiltFrame = null;
            }
            referencesWrapper.style.setProperty('--tilt-x', '0deg');
            referencesWrapper.style.setProperty('--tilt-y', '0deg');
        };
        references.addEventListener('mouseover', (event)=>{
            const link = event.target.closest('a');
            if (!link) return;
            isOverReferencesLink = true;
            resetTiltImmediately();
        });
        references.addEventListener('mouseout', (event)=>{
            const link = event.target.closest('a');
            if (!link) return;
            const to = event.relatedTarget;
            if (to && link.contains(to)) return;
            isOverReferencesLink = false;
        });
        references.addEventListener('mousemove', (event)=>{
            if (isOverReferencesLink || event.target.closest('a')) {
                resetTiltImmediately();
                return;
            }
            const rect = references.getBoundingClientRect();
            const x = (event.clientX - rect.left) / rect.width;
            const y = (event.clientY - rect.top) / rect.height;
            const rotateY = (x - 0.5) * 3;
            const rotateX = (0.5 - y) * 2.25;
            targetRotateX = rotateX;
            targetRotateY = rotateY;
            queueTiltRender();
        });
        references.addEventListener('mouseleave', ()=>{
            targetRotateX = 0;
            targetRotateY = 0;
            queueTiltRender();
        });
    }
    // ─── Scroll vers un slide (1-based) ────────────────────────────────────
    const scrollToSlide = (idx)=>{
        if (!slideContainer) return;
        slideContainer.scrollTo({
            top: (idx - 1) * window.innerHeight,
            behavior: 'smooth'
        });
    };
    // ─── Détection du slide visible ─────────────────────────────────────────
    let swipeTimer;
    let swipeTimer2;
    let hint1shown = false;
    let hint2shown = false;
    const slideObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if ($388b617130f03bd4$var$containsClass(entry.target, 'works')) {
                if (entry.isIntersecting) $388b617130f03bd4$var$addClass(document.documentElement, 'works-visible');
                else $388b617130f03bd4$var$removeClass(document.documentElement, 'works-visible');
            }
            if ($388b617130f03bd4$var$containsClass(entry.target, 'references')) {
                if (entry.isIntersecting) $388b617130f03bd4$var$addClass(document.documentElement, 'references-visible');
                else $388b617130f03bd4$var$removeClass(document.documentElement, 'references-visible');
            }
            if (entry.isIntersecting) {
                if ($388b617130f03bd4$var$containsClass(entry.target, 'contributions')) $388b617130f03bd4$var$addClass(entry.target, 'animated');
                if ($388b617130f03bd4$var$containsClass(entry.target, 'references')) $388b617130f03bd4$var$addClass(entry.target, 'animated');
                if ($388b617130f03bd4$var$containsClass(entry.target, 'hero') && !hint1shown) {
                    hint1shown = true;
                    swipeTimer = setTimeout(()=>{
                        $388b617130f03bd4$var$$qa('.touch .slide-swipe').forEach((element)=>{
                            $388b617130f03bd4$var$addClass(element, 'vertical');
                        });
                        $388b617130f03bd4$var$$qa('.slide-swipe .icon').forEach((icon)=>{
                            icon.addEventListener(animationEnd, ()=>{
                                $388b617130f03bd4$var$$qa('.slide-swipe').forEach((element)=>{
                                    $388b617130f03bd4$var$removeClass(element, 'vertical');
                                });
                            }, {
                                once: true
                            });
                        });
                    }, 4000);
                }
                if ($388b617130f03bd4$var$containsClass(entry.target, 'works') && !hint2shown) {
                    hint2shown = true;
                    swipeTimer2 = setTimeout(()=>{
                        $388b617130f03bd4$var$$qa('.touch .slide-swipe').forEach((element)=>{
                            $388b617130f03bd4$var$addClass(element, 'horizontal');
                        });
                        $388b617130f03bd4$var$$qa('.slide-swipe .icon').forEach((icon)=>{
                            icon.addEventListener(animationEnd, ()=>{
                                $388b617130f03bd4$var$$qa('.slide-swipe').forEach((element)=>{
                                    $388b617130f03bd4$var$removeClass(element, 'horizontal');
                                });
                            }, {
                                once: true
                            });
                        });
                    }, 600);
                }
            } else {
                if ($388b617130f03bd4$var$containsClass(entry.target, 'hero')) {
                    clearTimeout(swipeTimer);
                    $388b617130f03bd4$var$$qa('.slide-swipe').forEach((element)=>{
                        $388b617130f03bd4$var$removeClass(element, 'vertical');
                    });
                }
                if ($388b617130f03bd4$var$containsClass(entry.target, 'works')) {
                    clearTimeout(swipeTimer2);
                    $388b617130f03bd4$var$$qa('.slide-swipe').forEach((element)=>{
                        $388b617130f03bd4$var$removeClass(element, 'horizontal');
                    });
                }
            }
        });
    }, {
        root: slideContainer,
        threshold: 0.6
    });
    $388b617130f03bd4$var$$qa('.slide').forEach((slide)=>{
        slideObserver.observe(slide);
    });
    // ─── Navigation Works (horizontal) ─────────────────────────────────────
    const gotoPage = (idx)=>{
        page = idx;
        const firstWork = $388b617130f03bd4$var$$q('.work');
        if (!firstWork || !pageContainer) return;
        const width = firstWork.offsetWidth;
        pageContainer.scrollTo({
            left: (page - 1) * width,
            behavior: 'smooth'
        });
        const works = $388b617130f03bd4$var$$qa('.work', pageContainer);
        works.forEach((work)=>{
            $388b617130f03bd4$var$removeClass(work, 'active');
        });
        if (works[page - 1]) $388b617130f03bd4$var$addClass(works[page - 1], 'active');
        updatePageNavigation();
    };
    const nextPage = ()=>{
        if (page >= totalPages) return;
        page += 1;
        gotoPage(page);
    };
    const previousPage = ()=>{
        if (page <= 1) return;
        page -= 1;
        gotoPage(page);
    };
    const changePage = (e)=>{
        if (e.keyCode === 37) {
            e.preventDefault();
            previousPage();
        }
        if (e.keyCode === 39) {
            e.preventDefault();
            nextPage();
        }
    };
    if (pageContainer) pageContainer.addEventListener('scrollend', ()=>{
        const firstWork = $388b617130f03bd4$var$$q('.work', pageContainer);
        if (!firstWork) return;
        const workWidth = firstWork.offsetWidth;
        const newPage = Math.round(pageContainer.scrollLeft / workWidth) + 1;
        const works = $388b617130f03bd4$var$$qa('.work', pageContainer);
        page = Math.max(1, Math.min(newPage, totalPages));
        works.forEach((work)=>{
            $388b617130f03bd4$var$removeClass(work, 'active');
        });
        if (works[page - 1]) $388b617130f03bd4$var$addClass(works[page - 1], 'active');
        updatePageNavigation();
    });
    const updatePageNavigation = ()=>{
        if (!pageNavigation) return;
        const paginationLinks = $388b617130f03bd4$var$$qa('a', pageNavigation);
        const previousButton = $388b617130f03bd4$var$$q('.work-previous');
        const nextButton = $388b617130f03bd4$var$$q('.work-next');
        paginationLinks.forEach((link)=>{
            $388b617130f03bd4$var$removeClass(link, 'active');
        });
        if (paginationLinks[page - 1]) $388b617130f03bd4$var$addClass(paginationLinks[page - 1], 'active');
        if (previousButton) {
            $388b617130f03bd4$var$removeClass(previousButton, 'disabled');
            if (page === 1) $388b617130f03bd4$var$addClass(previousButton, 'disabled');
        }
        if (nextButton) {
            $388b617130f03bd4$var$removeClass(nextButton, 'disabled');
            if (page === totalPages) $388b617130f03bd4$var$addClass(nextButton, 'disabled');
        }
    };
    const isReferencesMobileSnap = ()=>window.matchMedia('(max-width: 1000px)').matches;
    const updateReferenceNavigation = ()=>{
        if (!referenceNavigation || !isReferencesMobileSnap()) return;
        const paginationLinks = $388b617130f03bd4$var$$qa('a', referenceNavigation);
        paginationLinks.forEach((link)=>{
            $388b617130f03bd4$var$removeClass(link, 'active');
        });
        if (paginationLinks[referencePage - 1]) $388b617130f03bd4$var$addClass(paginationLinks[referencePage - 1], 'active');
    };
    const getReferencePageFromScroll = ()=>{
        if (!referencesWrapper || referenceCards.length === 0) return 1;
        const currentLeft = referencesWrapper.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;
        referenceCards.forEach((card, index)=>{
            const distance = Math.abs(card.offsetLeft - currentLeft);
            if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
            }
        });
        return closestIndex + 1;
    };
    const gotoReferencePage = (idx)=>{
        referencePage = idx;
        if (!referencesWrapper || !referenceCards[referencePage - 1]) return;
        referencesWrapper.scrollTo({
            left: referenceCards[referencePage - 1].offsetLeft,
            behavior: 'smooth'
        });
        updateReferenceNavigation();
    };
    const initReferencesPagination = ()=>{
        if (!referenceNavigation) return;
        referenceNavigation.innerHTML = '';
        totalReferencePages = referenceCards.length;
        referencePage = Math.max(1, Math.min(referencePage, totalReferencePages || 1));
        if (!isReferencesMobileSnap() || totalReferencePages <= 1) return;
        for(let x = 0; x < totalReferencePages; x += 1){
            const link = document.createElement('a');
            link.href = '#';
            link.addEventListener('click', (e)=>{
                const links = $388b617130f03bd4$var$$qa('a', referenceNavigation);
                e.preventDefault();
                gotoReferencePage(Array.from(links).indexOf(e.currentTarget) + 1);
            });
            referenceNavigation.appendChild(link);
        }
        referencePage = getReferencePageFromScroll();
        updateReferenceNavigation();
    };
    const orientation = ()=>{
        const orientationAngle = screen.orientation ? screen.orientation.angle : 0;
        const swipeHints = $388b617130f03bd4$var$$qa('.touch .slide-swipe');
        if ($388b617130f03bd4$var$isMobile() && orientationAngle % 180 !== 0) swipeHints.forEach((element)=>{
            $388b617130f03bd4$var$addClass(element, 'orientation');
        });
        else swipeHints.forEach((element)=>{
            $388b617130f03bd4$var$removeClass(element, 'orientation');
        });
    };
    const initWorks = ()=>{
        const workElement = $388b617130f03bd4$var$$q('.work');
        updatePageNavigation();
        if (!workElement || !pageNavigation) {
            totalPages = 0;
            return;
        }
        const workWidth = workElement.getBoundingClientRect().width;
        const containerWidth = pageContainer ? pageContainer.clientWidth : window.innerWidth;
        const worksPerPage = Math.max(1, Math.floor(containerWidth / workWidth));
        totalPages = Math.ceil(totalWorks / worksPerPage);
        pageNavigation.innerHTML = '';
        if (totalPages <= 1) return;
        for(let x = 0; x < totalPages; x += 1){
            const link = document.createElement('a');
            link.href = '#';
            link.addEventListener('click', (e)=>{
                const links = $388b617130f03bd4$var$$qa('a', pageNavigation);
                e.preventDefault();
                gotoPage(Array.from(links).indexOf(e.currentTarget) + 1);
            });
            pageNavigation.appendChild(link);
        }
        updatePageNavigation();
        if (page > totalPages) {
            page = totalPages;
            gotoPage(page);
        }
    };
    // ─── Init ────────────────────────────────────────────────────────────────
    initWorks();
    gotoPage(page);
    initReferencesPagination();
    if ('ontouchstart' in window || 'onmsgesturechange' in window) document.documentElement.classList.add('touch');
    else document.documentElement.classList.add('no-touch');
    const wrapTextNodes = (root)=>{
        Array.from(root.childNodes).forEach((node)=>{
            if (node.nodeType === 3) {
                const wrapper = document.createElement('span');
                node.parentNode.insertBefore(wrapper, node);
                wrapper.appendChild(node);
            }
        });
    };
    $388b617130f03bd4$var$$qa('.hero-bio p').forEach((paragraph)=>{
        wrapTextNodes(paragraph);
    });
    const contributionsParagraph = $388b617130f03bd4$var$$q('.contributions p');
    if (contributionsParagraph) wrapTextNodes(contributionsParagraph);
    $388b617130f03bd4$var$$qa('.lang-btn').forEach((button)=>{
        button.addEventListener('click', (e)=>{
            e.preventDefault();
            const selectedLang = e.currentTarget.getAttribute('data-lang');
            document.documentElement.lang = selectedLang;
            document.documentElement.className = document.documentElement.className.replace(/\blang-\w+/g, '') + ' lang-' + selectedLang;
            localStorage.setItem('lang', selectedLang);
            const url = new URL(location.href);
            url.searchParams.set('lang', selectedLang);
            history.replaceState(null, '', url);
            $388b617130f03bd4$var$restartBubble(selectedLang);
        });
    });
    $388b617130f03bd4$var$$qa('.social-email a').forEach((link)=>{
        link.setAttribute('href', 'mailto:' + link.getAttribute('href').replace('#', '@').replace('|', '.'));
    });
    $388b617130f03bd4$var$$qa('.hero-scroll').forEach((button)=>{
        button.addEventListener('click', (e)=>{
            e.preventDefault();
            scrollToSlide(2);
        });
    });
    $388b617130f03bd4$var$$qa('.work-previous').forEach((button)=>{
        button.addEventListener('click', (e)=>{
            previousPage();
            e.preventDefault();
        });
    });
    $388b617130f03bd4$var$$qa('.work-next').forEach((button)=>{
        button.addEventListener('click', (e)=>{
            nextPage();
            e.preventDefault();
        });
    });
    if (referencesWrapper) {
        const syncReferencePagination = $388b617130f03bd4$var$debounce(()=>{
            if (!isReferencesMobileSnap() || totalReferencePages <= 1) return;
            referencePage = getReferencePageFromScroll();
            updateReferenceNavigation();
        }, 50);
        referencesWrapper.addEventListener('scroll', syncReferencePagination);
        referencesWrapper.addEventListener('scrollend', syncReferencePagination);
    }
    setTimeout(()=>{
        $388b617130f03bd4$var$$qa('.hero').forEach((hero)=>{
            hero.classList.add('animated');
        });
    }, 500);
    window.addEventListener('keydown', $388b617130f03bd4$var$debounce(changePage, 50));
    window.addEventListener('resize', $388b617130f03bd4$var$debounce(()=>{
        initWorks();
        initReferencesPagination();
    }, 250));
    window.addEventListener('orientationchange', orientation);
    window.dispatchEvent(new Event('orientationchange'));
});
// ─── Typing FX ───────────────────────────────────────────────────────────────
const $388b617130f03bd4$var$container = document.querySelector('.bubble-text');
const $388b617130f03bd4$var$sentences = [];
const $388b617130f03bd4$var$allSentences = [];
let $388b617130f03bd4$var$typingGen = 0;
$388b617130f03bd4$var$$qa('.bubble-text p').forEach((item)=>{
    $388b617130f03bd4$var$allSentences.push({
        text: item.innerHTML,
        wait: item.dataset.wait,
        back: item.dataset.back,
        lang: item.getAttribute('lang')
    });
});
const $388b617130f03bd4$var$collectSentences = (activeLang)=>{
    $388b617130f03bd4$var$sentences.length = 0;
    $388b617130f03bd4$var$allSentences.forEach((sentence)=>{
        if (!sentence.lang || sentence.lang === activeLang) $388b617130f03bd4$var$sentences.push(sentence);
    });
};
const $388b617130f03bd4$var$restartBubble = (activeLang)=>{
    $388b617130f03bd4$var$typingGen += 1;
    const gen = $388b617130f03bd4$var$typingGen;
    $388b617130f03bd4$var$collectSentences(activeLang);
    if (!$388b617130f03bd4$var$container) return;
    $388b617130f03bd4$var$container.innerHTML = '';
    $388b617130f03bd4$var$$qa('.bubble').forEach((bubble)=>{
        bubble.classList.add('shown');
    });
    $388b617130f03bd4$var$typing(0, gen);
};
$388b617130f03bd4$var$collectSentences(document.documentElement.lang);
if ($388b617130f03bd4$var$container) $388b617130f03bd4$var$container.innerHTML = '';
setTimeout(()=>{
    $388b617130f03bd4$var$typing(0, $388b617130f03bd4$var$typingGen);
}, 2000);
const $388b617130f03bd4$var$typing = (i, gen)=>{
    if (gen !== $388b617130f03bd4$var$typingGen || !$388b617130f03bd4$var$container) return;
    if (!$388b617130f03bd4$var$sentences[i]) {
        $388b617130f03bd4$var$$qa('.bubble').forEach((bubble)=>{
            bubble.classList.remove('shown');
        });
        return;
    }
    const sentence = $388b617130f03bd4$var$sentences[i];
    const text = sentence.text + '_';
    $388b617130f03bd4$var$forward(text, 0, ()=>{
        $388b617130f03bd4$var$typing(i + 1, gen);
    }, sentence.wait, sentence.back, gen);
};
const $388b617130f03bd4$var$forward = (text, x, done, wait, back, gen)=>{
    if (gen !== $388b617130f03bd4$var$typingGen || !$388b617130f03bd4$var$container) return;
    let blinking = '';
    const nextX = x + 1;
    if (nextX === text.length) blinking = 'bubble-blinking';
    const part = text.substring(0, nextX);
    const parts = '> ' + part.substring(0, nextX - 1) + '<span class="bubble-cursor ' + blinking + '">' + part.substring(nextX - 1, nextX) + '</span>';
    $388b617130f03bd4$var$container.innerHTML = parts;
    if (nextX < text.length) setTimeout(()=>{
        $388b617130f03bd4$var$forward(text, nextX, done, wait, back, gen);
    }, Math.random() * 70 + 10);
    else setTimeout(()=>{
        if (back) $388b617130f03bd4$var$backward(text, nextX, done, gen);
        else done();
    }, wait);
};
const $388b617130f03bd4$var$backward = (text, x, done, gen)=>{
    if (gen !== $388b617130f03bd4$var$typingGen || !$388b617130f03bd4$var$container) return;
    const nextX = x - 1;
    $388b617130f03bd4$var$container.innerHTML = '> ' + text.substring(0, nextX) + '<span class="bubble-cursor">_</span>';
    if (nextX !== 0) setTimeout(()=>{
        $388b617130f03bd4$var$backward(text, nextX, done, gen);
    }, Math.random() * 40);
    else done();
};
// ────────────────────────────────────────────────────────────────────────────
const $388b617130f03bd4$var$$cursor = document.querySelector('#cursor');
if ($388b617130f03bd4$var$$cursor) {
    let cursorX = 0;
    let cursorY = 0;
    let cursorFrame = null;
    let hoverState = false;
    let lastTouchAt = 0;
    const clearHover = ()=>{
        $388b617130f03bd4$var$$cursor.classList.remove('hover');
        hoverState = false;
    };
    const renderCursor = ()=>{
        $388b617130f03bd4$var$$cursor.style.left = `${cursorX}px`;
        $388b617130f03bd4$var$$cursor.style.top = `${cursorY}px`;
        const hovered = document.elementFromPoint(cursorX, cursorY);
        const isOverLink = !!(hovered && hovered.closest('a'));
        if (isOverLink !== hoverState) {
            $388b617130f03bd4$var$$cursor.classList.toggle('hover', isOverLink);
            hoverState = isOverLink;
        }
        cursorFrame = null;
    };
    window.addEventListener('mousemove', (e)=>{
        if (Date.now() - lastTouchAt < 500) return;
        cursorX = e.clientX;
        cursorY = e.clientY;
        if (!cursorFrame) cursorFrame = requestAnimationFrame(renderCursor);
    });
    [
        'touchstart',
        'touchend',
        'touchcancel'
    ].forEach((event)=>{
        window.addEventListener(event, ()=>{
            lastTouchAt = Date.now();
            clearHover();
        });
    });
    window.addEventListener('mouseleave', clearHover);
}


//# sourceMappingURL=jaysalvat.com.5d04d2e1.js.map
